import React from "react";
import { FormatterType, TeamLogo } from "best-common-react";
import { EmailListRow } from "../types/emailList.ts";
import { MarketingCampaignRow } from "../types/marketing-campaign.ts";
import { formatCreatedAt } from "../util/DateUtil.ts";

export const TeamFormatter: React.FC<FormatterType<EmailListRow | MarketingCampaignRow>> = ({ row }) => {
  if (row?.teamId === 1) {
    return <TeamLogo teamId={1} />;
  } else if (!!row?.teamStatsId) {
    return <TeamLogo teamId={row.teamStatsId} />;
  } else {
    return null;
  }
};

export const CreatedAtFormatter: React.FC<FormatterType<EmailListRow | MarketingCampaignRow>> = ({ row }) => {
  return formatCreatedAt(row?.createdAt);
};
